module.exports = __webpack_public_path__ + "static/media/upve_logo-400.eed04da8.png";